import { ImpactCategory } from "../../../../domain/impactCategories";

export const titleOver2Lines = (
  impactCategory: ImpactCategory,
  locale: string | null
) =>
  locale === "fr-FR" &&
  (impactCategory === ImpactCategory.LAND_USE ||
    impactCategory === ImpactCategory.WATER_USE);
